module.exports = __webpack_public_path__ + "static2023-4-17/img/open.f17c0d5c.jpg";